import jwt_decode from 'jwt-decode';

/**
 * Check if the current token is expired
 * @returns {boolean} true if token is expired or invalid, false otherwise
 */
export const isTokenExpired = () => {
  try {
    const token = localStorage.getItem("token");
    
    if (!token) {
      return true; // No token means expired
    }

    // Decode token to check expiry
    const decoded = jwt_decode(token);
    const currentTime = Date.now() / 1000;
    
    // Check if token is expired (with 30 second buffer)
    return decoded.exp < (currentTime + 30);
  } catch (error) {
    console.error("Token validation error:", error);
    return true; // Invalid token means expired
  }
};

/**
 * Get token expiry time in milliseconds
 * @returns {number|null} expiry time in milliseconds or null if invalid
 */
export const getTokenExpiryTime = () => {
  try {
    const token = localStorage.getItem("token");
    
    if (!token) {
      return null;
    }

    const decoded = jwt_decode(token);
    return decoded.exp * 1000; // Convert to milliseconds
  } catch (error) {
    console.error("Token decode error:", error);
    return null;
  }
};

/**
 * Get time remaining until token expires in seconds
 * @returns {number} seconds remaining or 0 if expired/invalid
 */
export const getTokenTimeRemaining = () => {
  try {
    const token = localStorage.getItem("token");
    
    if (!token) {
      return 0;
    }

    const decoded = jwt_decode(token);
    const currentTime = Date.now() / 1000;
    const timeRemaining = decoded.exp - currentTime;
    
    return Math.max(0, timeRemaining);
  } catch (error) {
    console.error("Token time calculation error:", error);
    return 0;
  }
};

/**
 * Check if token will expire within specified minutes
 * @param {number} minutes - minutes to check ahead
 * @returns {boolean} true if token expires within specified minutes
 */
export const isTokenExpiringSoon = (minutes = 5) => {
  try {
    const token = localStorage.getItem("token");
    
    if (!token) {
      return true;
    }

    const decoded = jwt_decode(token);
    const currentTime = Date.now() / 1000;
    const expiryTime = decoded.exp;
    const warningTime = currentTime + (minutes * 60);
    
    return expiryTime <= warningTime;
  } catch (error) {
    console.error("Token expiry warning error:", error);
    return true;
  }
};
